import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BnzButtonComponent } from './button.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BnzButtonComponent],
  exports: [BnzButtonComponent],
})
export class BnzButtonModule {}
